import React from 'react';
import { Navigate } from 'react-router-dom';

function OwnerAdminRouteGuard({ user, children }) {
  const isOwnerAdmin = user?.role === 'Admin';
  const isSuperAdminView =
    user?.role === 'Super Admin' && (!user?.viewMode || user.viewMode === 'super_admin');

  if (!isOwnerAdmin && !isSuperAdminView) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default OwnerAdminRouteGuard;
